var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "virtual-scroller-wrapper" }, [
    _c(
      "div",
      {
        ref: "scroller",
        staticClass: "virtual-scroller",
        on: { scroll: _vm.handleScroll },
      },
      [
        _c(
          "div",
          {
            staticClass: "scroller-content",
            style: { height: _vm.totalSize + "px" },
          },
          [
            _c(
              "div",
              {
                staticClass: "items-container",
                style: { top: _vm.offsetTop + "px" },
              },
              _vm._l(_vm.visibleItems, function (item, index) {
                return _c(
                  "div",
                  {
                    key: _vm.getItemKey(item, index),
                    staticClass: "virtual-item",
                  },
                  [
                    _vm._t("default", null, {
                      item: item,
                      index: _vm.startIndex + index,
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _vm.showEmptyPlaceholder
          ? _c(
              "div",
              { staticClass: "virtual-scroller-empty" },
              [
                _vm._t("empty", function () {
                  return [
                    _c("div", { staticClass: "empty-placeholder" }, [
                      _vm._v(_vm._s(_vm.emptyText)),
                    ]),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "virtual-scroller-loading" },
              [
                _vm._t("loading", function () {
                  return [
                    _c("div", { staticClass: "loading-indicator" }, [
                      _vm._v(_vm._s(_vm.$t("table.loading"))),
                    ]),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "virtual-scroller-portals" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }